import React from "react";
import PropTypes from "prop-types";
import FormManager from "./form-manager";

const ManagedForm = ({ render, children, ...props }) => {
  const renderProp = typeof render === "function" ? render : children;
  return (
    <FormManager {...props}>
      {({ isDisabled, state, setState, errors, handleSubmit }) => (
        <form
          autoComplete={props.disableAutoComplete ? "off" : "on"}
          onSubmit={e => {
            e.preventDefault();
            if (!props.disableEnterKeyOnForm) {
              handleSubmit(state, setState);
            }
          }}
        >
          {renderProp({
            state,
            setState,
            errors,
            isDisabled,
          })}
        </form>
      )}
    </FormManager>
  );
};

ManagedForm.propTypes = {
  render: PropTypes.func,
  children: PropTypes.func,
  disableAutoComplete: PropTypes.bool,
  disableEnterKeyOnForm: PropTypes.bool,
};

ManagedForm.displayName = "ManagedForm";

export default ManagedForm;
